import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { safeSessionStorage } from '@/lib/safeStorage';

export default function NavigationTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const prev = safeSessionStorage.getItem('currentPath');
    if (prev) {
      safeSessionStorage.setItem('previousPath', prev);
    }
    safeSessionStorage.setItem('currentPath', location.pathname + location.search);

    if (typeof document === 'undefined') {
      return;
    }

    const main = document.getElementById('main-content');

    if (!main) {
      return;
    }

    if (typeof main.scrollTo === 'function') {
      main.scrollTo({ top: 0 });
    } else {
      main.scrollTop = 0;
    }

    const focusMain = () => {
      if (typeof main.focus !== 'function') {
        return;
      }

      try {
        main.focus({ preventScroll: true });
      } catch {
        // preventScroll stöds inte i äldre browsers – fall tillbaka till standardbeteende
        main.focus();
      }
    };

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(() => focusMain());
    } else {
      window.setTimeout(focusMain, 0);
    }
  }, [location]);

  return null;
}
